import {
  TicketStatus
} from '../../../../../core';

export const supportTickets = {
  paginator: false,
  iconsOfActions: [],
  show: 'No hay registros para mostrar',
  alterColumns: false,
  expandable: false,
  
  columns: [
    {
      title: 'Ticket ID',
      name: 'SystemId',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: TicketStatus) => element.SystemId
    },
    {
      title: 'Titulo',
      name: 'SystemTitle',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: TicketStatus) => element.SystemTitle
    },
    {
      title: 'Asignado a',
      name: 'SystemAssignedTo',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: false,
      visible: true,
      class: 'left',
      value: (element: TicketStatus) => (element.SystemAssignedTo || '')
    },
    {
      title: 'Estado',
      name: 'SystemState',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'center w120',
      value: (element: TicketStatus) => element.SystemState
    },
    {
      title: 'Compañía',
      name: 'CustomSuppCia',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: TicketStatus) => element.CustomSuppCia
    },
    {
      title: 'Autor',
      name: 'CustomSuppEmail',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: TicketStatus) => element.CustomSuppEmail
    }
  ]
};
